import { Dialog as ChakraDialog, DialogContentProps } from '@chakra-ui/react/dialog'
import { Portal } from '@chakra-ui/react/portal'
import { CloseButton } from './close-button'
import * as React from 'react'

export const DialogContent = React.forwardRef(function DialogContent(
  props: DialogContentProps & {
    portalled?: boolean
    portalRef?: React.RefObject<HTMLDivElement | null>
    backdrop?: boolean
  },
  ref?: React.Ref<HTMLDivElement>,
) {
  const { children, portalled = true, portalRef, backdrop = true, ...rest } = props

  return (
    <Portal disabled={!portalled} container={portalRef}>
      {backdrop && <ChakraDialog.Backdrop />}
      <ChakraDialog.Positioner>
        <ChakraDialog.Content ref={ref} {...rest} asChild={false}>
          {children}
        </ChakraDialog.Content>
      </ChakraDialog.Positioner>
    </Portal>
  )
})

export const DialogCloseTrigger = React.forwardRef(function DialogCloseTrigger(
  props: React.PropsWithChildren<{ color?: string; _hover?: { bg?: string } }>,
  ref?: React.Ref<HTMLButtonElement>,
) {
  return (
    <ChakraDialog.CloseTrigger position="absolute" top="2" insetEnd="2" {...props} asChild>
      <CloseButton size="sm" ref={ref}>
        {props.children}
      </CloseButton>
    </ChakraDialog.CloseTrigger>
  )
})

export const DialogRoot = ChakraDialog.Root
export const DialogFooter = ChakraDialog.Footer
export const DialogHeader = ChakraDialog.Header
export const DialogBody = ChakraDialog.Body
export const DialogBackdrop = ChakraDialog.Backdrop
export const DialogTitle = ChakraDialog.Title
export const DialogDescription = ChakraDialog.Description
export const DialogTrigger = ChakraDialog.Trigger
export const DialogActionTrigger = ChakraDialog.ActionTrigger
